<angular-editor
  id="editor1"
  formControlName="htmlContent1"
  [config]="editorConfig"
>
  <ng-template #customButtons let-executeCommandFn="executeCommandFn">
    <ae-toolbar-set>
      <ae-button
        iconClass="fa fa-html5"
        title="Angular editor logo"
        (buttonClick)="executeCommandFn('insertHtml')"
      >
      </ae-button>
    </ae-toolbar-set>
  </ng-template>
</angular-editor>
